import type { Profile } from "../models/profile";

export interface ProfileProps {
    profile: Profile;
}

export interface GeneratedPostResponse {
    caption: string;
    mediaPrompt: string;
    dateTime: string;
    hashtags: string[];
    inspiration: string;
    theme: string;
    fromUserMedia?: boolean;
}

export interface GeneratedPlanningResponse {
    posts: GeneratedPostResponse[];
}

// Tutoiement ou vouvoiement
export enum Familiarity {
    Familiar = "Familiar",
    Formal = "Formal",
}

export enum Emojis {
    Yes = "Yes",
    Moderated = "Moderated",
    No = "No",
}

export enum LengthModifier {
    Shorter = "Shorter",
    Longer = "Longer",
}

export interface ModifiersRequest {
    emojis?: string | null;
    themes?: string[] | null;
    description?: LengthModifier | null;
    tone?: string[] | null;
    additionalInfo?: string | null;
}
